import { gql } from '@apollo/client';

export const CREATE_CONTRACT_AGREEMENT = gql`
  mutation Flex_CreateContractAgreements($input: [CreateContractAgreementInput!]!) {
    createContractAgreements(input: $input) {
      success
    }
  }
`;
